import PropTypes from 'prop-types'
import React from 'react'
import { FaChevronLeft, FaChevronRight, FaPowerOff } from 'react-icons/fa'
import {
  CloseButton,
  NameOrder,
  NameProject,
  NavBody,
  NavFooter,
  NavHeader,
  SaveButton,
  Sidebar as StyledSidebar,
} from './theme'

const Sidebar = ({ projectName, projectOrder, isClosed, toggleSidebar, children, saveProject }) => (
  <StyledSidebar isClosed={isClosed}>
    <CloseButton onClick={toggleSidebar}>{isClosed === true ? <FaChevronRight /> : <FaChevronLeft />}</CloseButton>
    <NavHeader>
      {'' !== projectOrder && <NameOrder>{projectOrder}</NameOrder>}
      <NameProject>{projectName}</NameProject>
    </NavHeader>
    <NavBody>{children}</NavBody>
    <NavFooter>
      <SaveButton onClick={saveProject}>
        <FaPowerOff /> Wyjdź i zapisz projekt
      </SaveButton>
    </NavFooter>
  </StyledSidebar>
)

Sidebar.propTypes = {
  projectName: PropTypes.string.isRequired,
  projectOrder: PropTypes.string.isRequired,
  isClosed: PropTypes.bool,
  toggleSidebar: PropTypes.func.isRequired,
  saveProject: PropTypes.func.isRequired,
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js